import React from "react";

function SelectInput(props) {   
  const { t } = props;
  const errors = props.validation && props.validation.errors ? props.validation.errors : "";
  const isDirty = props.validation && props.validation.dirty ? props.validation.dirty : false;
  const formClass = errors[props.name] && isDirty[props.name] ? "form-group invalid" : "form-group";
  
  return (
    <div className={formClass}>
      {props.label && props.label.length && (<label htmlFor={props.id}>{props.label} {props.required && <span>*</span>}</label>)}
      <select
        className="form-control form-select"
        id={props.id}
        name={props.name}
        onChange={props.onChange}
        required={props.required}
        value={props.value}
      >
        <option value="">{props.defaultText}</option>
        {props.itemLookUp.map((item) => {
          return (
            <option key={item.id ? item.id : item.code} value={item.code}>
              { props.language === "en" ? item.nameEn : item.nameAr } 
            </option>
          );
        })}
      </select>      
      {errors[props.name] && isDirty[props.name] && (
        <div className="error-message">{t(errors[props.name])}</div>
      )}      
    </div>
  );
}

export default SelectInput;
